import React from 'react'
import layoutStyles from '../../containers/AppLayout/styles.module.less'
import { TradeFormValues } from '../../containers/TradeForm/Types'
import { AccountDetails, Correspondent } from '../../types'
import { getAppConfigSetting } from '../../utils'
import styles from './AccountInfoBar.module.less'
import InfoDetail from './components/InfoDetail'

export interface AccountInfoPreviewProps {
  accountDetails: AccountDetails
  correspondent: Correspondent
  values: TradeFormValues
}

const AccountInfoPreview: React.FunctionComponent<AccountInfoPreviewProps> = ({
  accountDetails: { accountNumber, accountTitle, restrictionCode },
  correspondent: { name, code },
  values: { accountType, repCode },
}: AccountInfoPreviewProps) => (
  <div className={layoutStyles.offsetBar}>
    <div className={`${styles.accountInfoBar} account-info-preview`}>
      <InfoDetail label={'Title'}>
        <span>{accountTitle}</span>
      </InfoDetail>
      <InfoDetail label={'Account #'}>
        <a
          href={`${getAppConfigSetting('appsUrl')}/accounts/#/${accountNumber}`}
          target={'_blank'}
          rel="noopener noreferrer"
        >
          {accountNumber}
        </a>
      </InfoDetail>
      <InfoDetail label={'Corr Name'}>
        <span>{name}</span>
      </InfoDetail>
      <InfoDetail label={'Corr Code'}>
        <span>{code}</span>
      </InfoDetail>
      {restrictionCode && (
        <InfoDetail label={'Account Rest.'}>
          <span className={styles.textRed}>{restrictionCode}</span>
        </InfoDetail>
      )}
      <InfoDetail label={'Rep Code *'}>
        <span>{repCode}</span>
      </InfoDetail>
      <InfoDetail label={'Account Type *'}>
        <span>{accountType}</span>
      </InfoDetail>
    </div>
  </div>
)

export default AccountInfoPreview
